var previousIndex = function previousIndex(activeSlide, slidesCount, isInfinite) {
  if (activeSlide) return activeSlide - 1;
  if (isInfinite) return slidesCount - 1;
  return activeSlide;
};
var nextIndex = function nextIndex(activeSlide, slidesCount, isInfinite) {
  if (activeSlide < slidesCount - 1) return activeSlide + 1;
  if (isInfinite) return 0;
  return activeSlide;
};

export { nextIndex, previousIndex };
//# sourceMappingURL=utils.js.map
